
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import TransProgramPersonWDisContent from "@/components/transPrograms/TransProgramPersonWDisContent.vue";
import { IBreadCrumbRoute } from "@/types";
import LearnMore from "@/components/common/LearnMore.vue";

export default Vue.extend({
  name: "tran-program-person-w-dis",
  components: {
    HeroBanner,
    BreadCrumb,
    TransProgramPersonWDisContent,
    LearnMore,
  },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transProgramOverview" },
          text: "Transportation Programs",
        },
        {
          to: { name: "transProgramPersonWDis" },
          text: "Programs for Persons with Disabilities",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "PGM_PWD,TPD_HERO_C,TPD_LEARN,TPD_CON_1A,TPD_CON_1B,TPD_CON_1C,TPD_CON_2A"
    );
  },
});
